import React from "react";
import avtar from "../../Assets/Images/image copy 2.png";
import card3 from "../../Assets/Images/AIImg.png";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dark } from "react-syntax-highlighter/dist/esm/styles/prism";
import TypedResponse from "../../pages/TypedResponse";
import { IMAGE_URL } from "../../API";

function MessageItem({ msg, profile, onTypingComplete }) {
  const userImage = profile?.image ? `${IMAGE_URL}${profile.image}` : avtar;

  return (
    <div className={`chat_inn_box ${msg.isUser ? "second_user_txt-flex" : ""}`}>
      <div className="img-chat-date d-flex">
        <div className="profile-chat-img">
          <img src={msg.isUser ? userImage : card3} alt={msg.isUser ? "User" : "AI"} />
        </div>

        <div className="chat_box_outer">
          <div className="chat-box">
            <div className={`chat_text ${msg.isUser ? "second_user_txt" : "first_user_txt"}`}>
              {msg.isTyping ?
                (<TypedResponse
                  fullText={msg.fullText}
                  typingSpeed={10}
                  isTyping={true}
                  onComplete={() => onTypingComplete(msg.id)}
                />)
                :
                msg.isUser ?
                  (<p>{msg.text}</p>)
                  :
                  (<ReactMarkdown
                    components={{
                      code({ node, inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || "");
                        return !inline && match ? (
                          <SyntaxHighlighter
                            style={dark}
                            language={match[1]}
                            PreTag="div"
                            {...props}
                          >
                            {String(children).replace(/\n$/, "")}
                          </SyntaxHighlighter>
                        ) : (
                          <code className={className || "inline-code"} {...props}>
                            {children}
                          </code>
                        );
                      },
                      ul({ children }) { return <ul className="markdown-list">{children}</ul> },
                      ol({ children }) { return <ol className="markdown-list">{children}</ol> },
                      li({ children }) { return <li className="markdown-list-item">{children}</li> },
                      p({ children }) { return <p className="markdown-paragraph">{children}</p> },
                    }}
                  >
                    {msg.text}
                  </ReactMarkdown>
                  )
              }
            </div>

            <span className={`cs_chat_time ${msg.isUser ? "second" : "first"}`}>
              {msg.timestamp}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessageItem;